export default {
    NAME: 'Kaetram',
    DESCRIPTION:
        'Kaetram - это игровой движок с открытым исходным кодом, созданный для помощи тем, кто хочет начать заниматься разработкой игр. За основу была взята демонстрационная игра компании Little Workshop - BrowserQuest. Активы остались прежними, но сам код был полностью вычищен и переделан с нуля.'
} as const;
